<template>
    <div class="modal fade" id="overlay-modal" tabindex="-1" data-bs-backdrop="static">
        <div class="modal-dialog modal-lg">
            <template v-if='loading'>
                <loader-modal />
            </template>
            <template v-if='!loading'>
                <div class="modal-content">
                    <div class="modal-body p-5">

                        <h5 class='' style="color:#3c3739;">{{ title }}</h5>

                        <template v-if="filesDropzoneOptions.url != null">
                            <dropzone class="mb-3 mt-1" :options="filesDropzoneOptions" @success="filesSuccess" @queuesuccess="filesQueueSuccess" @error="forceHide"></dropzone>
                        </template>

                        <div class='text-end'>
                            <button id="cancelBtn" type='button' class='btn btn-outline-primary' @click="askToCancel">
                                Annuler
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import loaderModal from '../common/loader/loader.modal.vue';
import dropzone from '../common/form/form.dropzone.vue';


export default {
    components : { loaderModal, dropzone },
    data : function() {
        return {
            loading : true,
            filesDropzoneOptions : {
                'url' : null,
                paramName: 'file',
                maxFiles : this.params.maxFiles ?? 1,
                acceptedFiles : this.params.acceptedFiles ?? null,
                maxFilesize: this.params.acceptedFiles ?? 50,
                dictDefaultMessage: (this.params.maxFiles ?? 1) > 1 ? "Glissez plusieurs fichiers ici" : "Glissez un fichier ici"
            },
            uploadedFiles : [],
            sessionUpload : null,
            timeout : null,
        };
    },
    props: {
        params : { type : Object, required : true},
        companyCode: {type: String, required: true},
        sessionId : { type : Number , required : true }
    },
    mounted : function() {
        window.clearTimeout(this.timeout);

        this.filesDropzoneOptions.url = '/api/v1/sessions/'+this.sessionId+'/uploads/' + this.companyCode + '/' + this.params.uuid + '/file';

        const vm = this;
        var overlayModalEl = document.getElementById('overlay-modal');
        var overlayModal = new bootstrap.Modal(overlayModalEl, { 'backdrop' : 'static', 'keyboard' : false});
        overlayModal.toggle();

        // on modal close
        // overlayModalEl.addEventListener('hidden.bs.modal', function (event) {
        //     vm.cancelOverlay(this.params.uuid);
        // });

        axios.post('/api/v1/sessions/' + this.sessionId + '/uploads/' + this.companyCode + '/' + this.params.uuid).then(response => {
            this.sessionUpload = response.data.data;
            this.loading = false;
        }).catch(error => { this.$httpError({ error: error }); });
    },
    methods : {
        filesSuccess : function (e) {
            this.uploadedFiles.push({
                'id' : e.data.id,
                'name' : e.data.name,
            });
        },
        filesQueueSuccess : function (e) {
            this.loading = true;

            axios.put('/api/v1/sessions/' + this.sessionId + '/uploads/' + this.companyCode + '/' + this.params.uuid, { 'state' : "terminated"}).then(response => {

                this.timeout = window.setTimeout(()=>{
                    // this.cancelOverlay()
                },5000);

            }).catch(error => { this.$httpError({ error: error }); });
        },
        askToCancel : function() {
            this.loading = true;

            axios.put('/api/v1/sessions/' + this.sessionId + '/uploads/' + this.companyCode + '/' + this.params.uuid, { 'state' : "canceled"}).then(response => {

                this.timeout = window.setTimeout(()=>{
                    // this.cancelOverlay()
                },5000);

            }).catch(error => { this.$httpError({ error: error }); });
        },
        cancelOverlay : function () {
            this.$emit('cancel');
            this.forceHide();
        },
        forceHide : function () {
            var overlayModalEl = document.getElementById('overlay-modal');
            var overlayModal = bootstrap.Modal.getInstance(overlayModalEl);
            if (overlayModal != null)
            {
                overlayModal.hide();
            }
        }
    },
    computed : {
        title : function() {
            return this.params.title ?? (this.filesDropzoneOptions.maxFiles > 1 ? "Sélectionnez des fichiers  " : "Sélectionnez un fichier");
        }
    }
}
</script>

<style scoped>
#cancelBtn {
    color: #3c3739 !important;
    border-color : #3c3739 !important;
}
#cancelBtn:hover,#cancelBtn:focus {
    color: white !important;
    background-color : #3c3739 !important;
}
</style>
